/*! License details at fancyapps.com/license */
const n=n=>n&&null!==n&&n instanceof Element&&"nodeType"in n;export{n as isNode};
